import { startOfDay } from 'date-fns';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';
import { Account, InvoiceDetail } from 'store/models/invoiceDetail';

type FilterValue = string;
type ShowGiftButton = boolean;
type FromDate = Date;
type ToDate = Date;
type IsLoad = boolean;

export enum InvoiceFilterType {
    Any = 'ANY',
    Status = 'STATUS',
    Manual = 'MANUAL',
    InvoiceId = 'INVOICE_ID',
    UserId = 'USER_ID',
    PayerId = 'PAYER_ID',
    AccountId = 'ACCOUNT_ID',
    ContractId = 'CONTRACT_ID',
    EmployerId = 'EMPLOYER_ID',
    InvoiceName = 'INVOICE_NAME',
}

export enum InvoiceStatus {
    Sending = 'SENDING',
    WaitingDoc = 'WAITING_DOC',
    New = 'NEW',
    Prepaid = 'PREPAID',
    Payed = 'PAYED',
    Closed = 'CLOSED',
    Overdue = 'OVERDUE',
    Cancel = 'CANCEL',
}

export enum InvoiceDreamPayerType {
    HH = 'HH',
    Legal = 'LEGAL',
    Individual = 'INDIVID',
    Gift = 'GIFT',
}

export enum InvoicePayerType {
    Legal = 'legal',
    Individual = 'individ',
    Natural = 'natural',
}

export enum PaymentType {
    Bank = 'BANK',
    Admin = 'ADMIN',
    Assist = 'ASSIST',
    HH = 'HH',
    Bonus = 'BONUS',
    Discount = 'DISCOUNT',
}

export enum RefundStatus {
    New = 'NEW',
    Finish = 'FINISH',
}

// ----------------------- actions -------------------------------------
const SET_INVOICES_DATES = 'SET_INVOICES_DATES';
const SET_INVOICES_FILTER_TYPE = 'SET_INVOICES_FILTER_TYPE';
const SET_INVOICES_FILTER_VALUE = 'SET_INVOICES_FILTER_VALUE';
const SET_INVOICES_LOAD = 'SET_INVOICES_LOAD';
const SET_INVOICES_ITEMS = 'SET_INVOICES_ITEMS';
const SET_INVOICES_ACCOUNTS = 'SET_INVOICES_ACCOUNTS';
const SET_INVOICES_SHOW_GIFT_BUTTON = 'SET_INVOICES_SHOW_GIFT_BUTTON';

interface PayloadTypes {
    [SET_INVOICES_DATES]: { from: FromDate; to: ToDate };
    [SET_INVOICES_FILTER_TYPE]: InvoiceFilterType;
    [SET_INVOICES_FILTER_VALUE]: FilterValue;
    [SET_INVOICES_LOAD]: IsLoad;
    [SET_INVOICES_ITEMS]: InvoiceDetail[];
    [SET_INVOICES_ACCOUNTS]: Account[];
    [SET_INVOICES_SHOW_GIFT_BUTTON]: ShowGiftButton;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setDates = ActionCreator(SET_INVOICES_DATES);
export const setFilterType = ActionCreator(SET_INVOICES_FILTER_TYPE);
export const setFilterValue = ActionCreator(SET_INVOICES_FILTER_VALUE);
export const setLoad = ActionCreator(SET_INVOICES_LOAD);
export const setInvoices = ActionCreator(SET_INVOICES_ITEMS);
export const setAccountsByInvoices = ActionCreator(SET_INVOICES_ACCOUNTS);
export const setShowGiftButton = ActionCreator(SET_INVOICES_SHOW_GIFT_BUTTON);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface InvoicesState {
    from: FromDate;
    to: ToDate;
    invoices: InvoiceDetail[];
    accounts: Account[];
    filterType: InvoiceFilterType;
    filterValue: FilterValue;
    isLoad: IsLoad;
    showGiftButton: ShowGiftButton;
}

export const INVOICES_INITIAL_STATE: InvoicesState = {
    from: new Date('December 01, 2013 00:20:00'),
    to: startOfDay(new Date()),
    invoices: [],
    accounts: [],
    filterType: InvoiceFilterType.EmployerId,
    filterValue: '',
    isLoad: false,
    showGiftButton: false,
};

export default createReducer<InvoicesState, PayloadTypes>(INVOICES_INITIAL_STATE, {
    [SET_INVOICES_DATES]: (state, { payload }) => ({
        ...state,
        from: payload.from,
        to: payload.to,
    }),
    [SET_INVOICES_FILTER_TYPE]: (state, { payload }) => ({
        ...state,
        filterType: payload,
    }),
    [SET_INVOICES_FILTER_VALUE]: (state, { payload }) => ({
        ...state,
        filterValue: payload,
    }),
    [SET_INVOICES_LOAD]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_INVOICES_ITEMS]: (state, { payload }) => ({
        ...state,
        invoices: payload,
    }),
    [SET_INVOICES_ACCOUNTS]: (state, { payload }) => ({
        ...state,
        accounts: payload,
    }),
    [SET_INVOICES_SHOW_GIFT_BUTTON]: (state, { payload }) => ({
        ...state,
        showGiftButton: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
